<div
  class="flex w-60 rounded-full border bg-surface py-1 pr-1 text-fg-faint relative justify-between h-[34px]"
  [ngClass]="filter ? 'border-green-600 text-fg-muted' : 'border-edge-strong'"
>
  @if (filter?.displayName) {
    <div class="ml-4 text-fg-muted pr-4 truncate">
      {{ filter?.displayName }}
    </div>
  }
  @if (!filter?.displayName) {
    <div class="ml-4 font-light">{{ label }}</div>
  }
  @if (filter) {
    <button (click)="resetFilter()">
      <app-ng-icon class="text-2xl" strokeWidth="1.5" name="heroXCircle"></app-ng-icon>
    </button>
  } @else {
    <app-dropdown-minimal-menu class="mr-1">
      <app-dropdown-button>
        <app-ng-icon class="text-xl" strokeWidth="1.5" name="heroFunnel"></app-ng-icon>
      </app-dropdown-button>
      @for (val of filterValues; track val.id) {
        <app-dropdown-item (menuClick)="enableFilter(val)"
          >{{ val.displayName }}
        </app-dropdown-item>
      }
    </app-dropdown-minimal-menu>
  }
</div>
